"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";

interface MediaHeroProps {
  type?: string;
  media?: string[];
  interval?: number;
  handleNextSlide: () => void;
}

const MediaHero: React.FC<MediaHeroProps> = ({
  type = "image",
  media = [],
  interval = 5000,
  handleNextSlide,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (type === "MultiImage" && isPlaying && media.length > 1) {
      timer = setInterval(() => {
        handleNextSlide();
      }, interval);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isPlaying, interval, media.length, type]);

  const renderMedia = () => {
    if (!media.length) return null;

    if (type === "Video") {
      return (
        <>
          {media[0] && (
            <video
              key={media[0]}
              src={media[0]}
              autoPlay
              loop
              muted
              preload="auto"
              disablePictureInPicture
              onLoadedData={() => setIsLoaded(true)}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "brightness(0.5)",
                opacity: isLoaded ? 1 : 0,
                transition: "opacity 0.3s ease-in",
              }}
            />
          )}
        </>
      );
    }

    if (type === "MultiImage") {
      return (
        <Image
          src={media[0]}
          alt={type}
          width={50}
          height={50}
          unoptimized
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(0.5)",
          }}
          onLoad={() => {
            setIsPlaying(true);
          }}
        />
      );
    }
    return (
      <Image
        src={media[0]}
        alt={type}
        width={50}
        height={50}
        unoptimized
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "brightness(0.5)",
        }}
      />
    );
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      {renderMedia()}
    </div>
  );
};

export default MediaHero;
